let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("9gF6b")]).then(() => parcelRequire('aG5pa'));